import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { UserAvatar } from '../../../components/UserAvatar';
import { KanbanProgressBar } from '../../KanbanBoards/components/ProgressBar';

const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class UserInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const user = this.props.user;
    return (
      <Card className="user-info-card info-card info">
        <Container>
          <HBox vCenter left>
            <UserAvatar user={user} />
            <VBox>
              <h3>
                {user.name}&nbsp;{user.surname}
              </h3>
            </VBox>
          </HBox>
          <KanbanProgressBar type="user" target={user} height={9} width={350} />
        </Container>
      </Card>
    );
  }
}

UserInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const UserInfoCard = compose(
  withConnect,
  withRouter,
)(UserInfoCardComp);
